import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService, LoginResult } from 'app/services/auth.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { CredentialsModel } from 'app/views/user/models/credentials.model';

@Component({
    selector: 'psm-login-form',
    templateUrl: 'loginForm.component.html',
    styleUrls: ['loginForm.component.scss']
})

export class LoginFormComponent {
    @Output() public loginDone: EventEmitter<LoginResult> = new EventEmitter<LoginResult>();
    public credentials: CredentialsModel = new CredentialsModel();
    public isWaiting: boolean;

    private logger: Logger;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('LoginComponent');
    }

    public async login() {
        this.isWaiting = true;
        let result = await this.authService.logIn(this.credentials.username, this.credentials.password);
        if (result === LoginResult.Connected) {
            this.credentials = new CredentialsModel();
        }

        this.loginDone.emit(result);
        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/loginForm/loginForm.component.ts